import { RouteDefinition } from './types';

export default [
	{
		path: '/:pathMatch(.*)*',
		name: 'NotFound',
		component: () => import('~/views/ErrorPage.vue'),
		props: { statusCode: 404 },
	},
	{
		path: '/dashboard',
		name: 'Dashboard',
		component: () => import('~/views/Dashboard.vue'),
		meta: {
			redirectToChild: true,
		},
		children: [
			{
				path: '/dashboard/audits',
				name: 'DashboardAudits',
				component: () => import('~/views/DashboardAudits.vue'),
				meta: {
					permissions: [ {
						subject: 'Dashboard',
						action: 'audit',
					} ],
				},
			},
			{
				path: '/dashboard/audit-questions',
				name: 'DashboardAuditQuestions',
				component: () => import('~/views/DashboardAuditQuestions.vue'),
				meta: {
					permissions: [ {
						subject: 'Dashboard',
						action: 'audit',
					} ],
				},
			},
			{
				path: '/dashboard/planner',
				name: 'DashboardPlanner',
				component: () => import('~/views/DashboardPlanner.vue'),
				meta: {
					permissions: [ {
						subject: 'Dashboard',
						action: 'planner',
					} ],
				},
			},
			{
				path: '/dashboard/promo',
				name: 'DashboardPromo',
				component: () => import('~/views/DashboardPromo.vue'),
				meta: {
					permissions: [ {
						subject: 'Dashboard',
						action: 'promo',
					} ],
				},
			},
		],
	},
	{
		path: '/profile',
		name: 'Profile',
		component: () => import('~/views/Profile.vue'),
		meta: {
			redirectToChild: true,
		},
		children: [
			{
				path: '/profile/detail',
				name: 'ProfileDetail',
				component: () => import('~/views/ProfileDetail.vue'),
				meta: {
					permissions: [
						{
							subject: 'Profile',
							action: 'all',
						},
					],
				},
			},
			{
				path: '/profile/settings',
				name: 'ProfileSettings',
				component: () => import('~/views/ProfileSettings.vue'),
				meta: {
					forbiddenAsAnotherAdmin: true,
				},
			},
			{
				path: '/profile/change-password',
				name: 'ProfilePassword',
				component: () => import('~/views/ProfilePasswordChange.vue'),
				meta: {
					forbiddenAsAnotherAdmin: true,
				},
			},
			{
				path: '/profile/edit',
				name: 'ProfileEditation',
				component: () => import('~/views/ProfileEdit.vue'),
				meta: {
					permissions: [
						{
							subject: 'Profile',
							action: 'edit',
						},
					],
					forbiddenAsAnotherAdmin: true,
				},
			},
		],
	},
	{
		path: '/planner',
		name: 'Planner',
		component: () => import('~/views/Planner.vue'),
		meta: {
			redirectToChild: true,
		},
		children: [
			{
				path: '/planner/my-calendar',
				name: 'PlannerCalendar',
				component: () => import('~/views/PlannerCalendar.vue'),
				meta: {
					permissions: [ {
						subject: 'Planner',
						action: 'all',
					} ],
				},
			},
			{
				path: '/planner/planning',
				name: 'PlannerPlanning',
				component: () => import('~/views/PlannerPlanning.vue'),
				meta: {
					redirectToChild: true,
					permissions: [ {
						subject: 'Planner',
						action: 'schedule',
					}, {
						subject: 'Planner',
						action: 'schedulePreview',
					} ],
				},
				children: [
					{
						path: '/planner/planning/poses',
						name: 'PlannerPlanningPoses',
						component: () => import('~/views/PlannerPlanningPoses.vue'),
						meta: {
							permissions: [ {
								subject: 'Planner',
								action: 'schedule',
							}, {
								subject: 'Planner',
								action: 'schedulePreview',
							} ],
						},
					},
					{
						path: '/planner/planning/users',
						name: 'PlannerPlanningUsers',
						component: () => import('~/views/PlannerPlanningUsers.vue'),
						meta: {
							permissions: [ {
								subject: 'Planner',
								action: 'schedule',
							}, {
								subject: 'Planner',
								action: 'schedulePreview',
							} ],
						},
					},
				],
			},
			{
				path: '/planner/activities',
				name: 'PlannerActivities',
				component: () => import('~/views/PlannerActivities.vue'),
				meta: {
					permissions: [ {
						subject: 'Planner',
						action: 'schedule',
					}, {
						subject: 'Planner',
						action: 'schedulePreview',
					} ],
				},
			},
			{
				path: '/planner/holidays',
				name: 'PlannerHolidays',
				component: () => import('~/views/PlannerHolidays.vue'),
				meta: {
					permissions: [ {
						subject: 'Planner',
						action: 'settings',
					} ],
				},
			},
			{
				path: '/planner/event-log',
				name: 'PlannerEventLogList',
				component: () => import('~/views/PlannerEventLogList.vue'),
				meta: {
					permissions: [ {
						subject: 'Planner',
						action: 'all',
					} ],
				},
			},
		],
	},
	{
		path: '/core/notification',
		name: 'Notifications',
		component: () => import('~/views/Notifications.vue'),
	},
	{
		path: '/settings/planner',
		name: 'SettingsPlanner',
		component: () => import('~/views/SettingsPlanner.vue'),
	},
	{
		path: '/settings/hierarchy',
		name: 'SettingsHierarchy',
		component: () => import('~/views/SettingsHierarchy.vue'),
	},
	{
		path: '/settings/employees',
		name: 'SettingsEmployees',
		component: () => import('~/views/SettingsEmployees.vue'),
	},
	{
		path: '/settings/audits',
		name: 'SettingsAudits',
		component: () => import('~/views/SettingsAudits.vue'),
	},
	{
		path: '/settings/audit-categories',
		name: 'SettingsAuditCategories',
		component: () => import('~/views/SettingsAuditCategories.vue'),
	},
	{
		path: '/settings/tags',
		name: 'SettingsTags',
		component: () => import('~/views/SettingsTags.vue'),
	},
	{
		path: '/settings/forms',
		name: 'SettingsForms',
		component: () => import('~/views/SettingsForms.vue'),
	},
	{
		path: '/settings/dashboard',
		name: 'SettingsDashboard',
		component: () => import('~/views/SettingsDashboard.vue'),
	},
	{
		path: '/settings/protocol',
		name: 'SettingsProtocol',
		component: () => import('~/views/SettingsProtocol.vue'),
	},
	{
		path: '/settings/release-notes',
		name: 'SettingsReleaseNotes',
		component: () => import('~/views/SettingsReleaseNotes.vue'),
	},
	{
		path: '/settings/stock',
		name: 'SettingsStock',
		component: () => import('~/views/SettingsStock.vue'),
	},
	{
		path: '/settings/campaign',
		name: 'SettingsCampaign',
		component: () => import('~/views/SettingsCampaign.vue'),
	},
	{
		path: '/settings/printers',
		name: 'SettingsPrinters',
		component: () => import('~/views/SettingsPrinters.vue'),
	},
	{
		path: '/audit',
		name: 'Audits',
		component: () => import('~/views/Audits.vue'),
		meta: {
			redirectToChild: true,
		},
		children: [
			{
				path: '/audit/audits',
				name: 'AuditsList',
				component: () => import('~/views/AuditsList.vue'),
				meta: {
					permissions: [ {
						subject: 'Audit',
						action: 'all',
					} ],
				},
			},
			{
				path: '/audit/results',
				name: 'AuditsResults',
				component: () => import('~/views/AuditsResults.vue'),
				meta: {
					redirectToChild: true,
				},
				children: [
					{
						path: '/audit/results/poses',
						name: 'AuditsResultsPoses',
						component: () => import('~/views/AuditsResultsPoses.vue'),
						meta: {
							permissions: [ {
								subject: 'Audit',
								action: 'all',
							} ],
						},
					},
					{
						path: '/audit/results/users',
						name: 'AuditsResultsUsers',
						component: () => import('~/views/AuditsResultsUsers.vue'),
						meta: {
							permissions: [ {
								subject: 'Audit',
								action: 'all',
							} ],
						},
					},
				],
			},

		],
	},
	{
		path: '/admins',
		name: 'Admins',
		component: () => import('~/views/Admins.vue'),
		meta: {
			redirectToChild: true,
		},
		children: [
			{
				path: '/admins/list',
				name: 'AdminsList',
				component: () => import('~/views/AdminsList.vue'),
				meta: {
					permissions: [ {
						subject: 'Admins',
						action: 'all',
					} ],
				},
			},
			{
				path: '/admins/:adminId',
				name: 'AdminsDetail',
				component: () => import('~/views/AdminsEdit.vue'),
				meta: {
					permissions: [ {
						subject: 'Admins',
						action: 'all',
					}, {
						subject: 'Admins',
						action: 'edit',
					} ],
				},
			},
			{
				path: '/admins/add',
				name: 'AdminsAddition',
				component: () => import('~/views/AdminsEdit.vue'),
				meta: {
					permissions: [ {
						subject: 'Admins',
						action: 'add',
					} ],
				},
			},
		],
	},
	{
		path: '/promo',
		name: 'Promos',
		component: () => import('~/views/Promos.vue'),
		meta: {
			redirectToChild: true,
			permissions: [ {
				subject: 'Promo',
				action: 'settings',
			} ],
		},
		children: [
			{
				path: '/promo/list',
				name: 'PromosList',
				component: () => import('~/views/PromosList.vue'),
				meta: {},
			},
			{
				path: '/promo/detail/:promoUuid',
				name: 'PromoDetail',
				component: () => import('~/views/PromosEdit.vue'),
				meta: {},
			},
			{
				path: '/promo/add',
				name: 'PromoAddition',
				component: () => import('~/views/PromosEdit.vue'),
				meta: {},
			},
			{
				path: '/promo/category/list',
				name: 'PromoCategoryList',
				component: () => import('~/views/PromoCategoryList.vue'),
				meta: {},
			},
		],
	},
	{
		path: '/library',
		name: 'Library',
		component: () => import('~/views/Library.vue'),
		meta: {
			redirectToChild: true,
		},
		children: [
			{
				path: '/library/information',
				name: 'LibraryInformation',
				component: () => import('~/views/LibraryInformation.vue'),
				meta: {
					permissions: [ {
						subject: 'Library',
						action: 'information',
					} ],
				},
			},
			{
				path: '/library/folders',
				name: 'LibraryFolderNotSelected',
				component: () => import('~/views/LibraryFolderNotSelected.vue'),
				meta: {
					permissions: [ {
						subject: 'Library',
						action: 'all',
					} ],
				},
			},
			{
				path: '/library/:folderId',
				name: 'LibraryFolder',
				component: () => import('~/views/LibraryFolder.vue'),
				meta: {
					permissions: [ {
						subject: 'Library',
						action: 'all',
					} ],
				},
			},
		],
	},
	{
		path: '/task',
		name: 'Tasks',
		component: () => import('~/views/Tasks.vue'),
		meta: {
			redirectToChild: true,
		},
		children: [
			{
				path: '/task/items/list',
				name: 'TaskItemsList',
				component: () => import('~/views/TasksItemsList.vue'),
				meta: {
					permissions: [ {
						subject: 'Task',
						action: 'all',
					} ],
				},
			},
			{
				path: '/task/list/recurring',
				name: 'TasksList',
				component: () => import('~/views/TasksList.vue'),
				meta: {
					permissions: [ {
						subject: 'Task',
						action: 'all',
					} ],
				},
			},
			{
				path: '/task/detail',
				name: 'TasksDetail',
				component: () => import('~/views/TasksDetail.vue'),
				meta: {
					permissions: [ {
						subject: 'Task',
						action: 'edit',
					} ],
				},
			},
			{
				path: '/task/task-types',
				name: 'TasksTaskTypes',
				component: () => import('~/views/TasksTaskTypes.vue'),
				meta: {
					permissions: [ {
						subject: 'Task',
						action: 'settings',
					} ],
				},
			},
		],
	},
	{
		path: '/store/product-serial-numbers',
		name: 'ProductHistory',
		component: () => import('~/views/ProductHistory.vue'),
	},
	{
		path: '/store/product-types',
		name: 'ProductType',
		component: () => import('~/views/ProductType.vue'),
	},
	{
		path: '/export/audit',
		name: 'ExportsAudits',
		component: () => import('~/views/ExportsAudits.vue'),
	},
	{
		path: '/campaign',
		name: 'Campaigns',
		component: () => import('~/views/Campaigns.vue'),
		meta: {
			redirectToChild: true,
		},
		children: [
			{
				path: '/campaign/overview',
				name: 'CampaignsOverview',
				component: () => import('~/views/CampaignsOverview.vue'),
				meta: {
					permissions: [ {
						subject: 'Campaign',
						action: 'all',
					} ],
				},
			},
			{
				path: '/campaign/add',
				name: 'CampaignsAddition',
				component: () => import('~/views/CampaignsEdit.vue'),
				meta: {
					permissions: [ {
						subject: 'Campaign',
						action: 'editCampaign',
					} ],
				},
			},
			{
				path: '/campaign/:campaignId',
				name: 'CampaignsDetail',
				component: () => import('~/views/CampaignsEdit.vue'),
				meta: {
					permissions: [ {
						subject: 'Campaign',
						action: 'editCampaign',
					} ],
				},
			},
			{
				path: '/campaign/key-visual/list',
				name: 'CampaignsKeyVisualList',
				component: () => import('~/views/CampaignsKeyVisualList.vue'),
				meta: {
					permissions: [ {
						subject: 'Campaign',
						action: 'all',
					} ],
				},
			},
			{
				path: '/campaign/key-visual/add',
				name: 'CampaignsKeyVisualAddition',
				component: () => import('~/views/CampaignsKeyVisualEdit.vue'),
				meta: {
					permissions: [ {
						subject: 'Campaign',
						action: 'editKv',
					} ],
				},
			},
			{
				path: '/campaign/key-visual/:keyVisualId',
				name: 'CampaignsKeyVisualDetail',
				component: () => import('~/views/CampaignsKeyVisualEdit.vue'),
				meta: {
					permissions: [ {
						subject: 'Campaign',
						action: 'editKv',
					} ],
				},
			},
			{
				path: '/campaign/campaign-split/:id?',
				name: 'CampaignsSplit',
				component: () => import('~/views/CampaignsSplit.vue'),
				meta: {
					permissions: [ {
						subject: 'Campaign',
						action: 'all',
					} ],
				},
			},
			{
				path: '/campaign/campaign-split-statistics',
				name: 'CampaignSplitStatistics',
				component: () => import('~/views/CampaignSplitStatistics.vue'),
				meta: {
					permissions: [ {
						subject: 'Campaign',
						action: 'viewSplitStatistics',
					} ],
				},
			},
			{
				path: '/campaign/additional-material/list',
				name: 'CampaignsAdditionalMaterialList',
				component: () => import('~/views/CampaignsAdditionalMaterialList.vue'),
				meta: {
					permissions: [ {
						subject: 'Campaign',
						action: 'all',
					} ],
				},
			},
			{
				path: '/campaign/additional-material/add',
				name: 'CampaignsAdditionalMaterialAddition',
				component: () => import('~/views/CampaignsAdditionalMaterialEdit.vue'),
				meta: {
					permissions: [ {
						subject: 'Campaign',
						action: 'createAdditionalMaterialRequest',
					} ],
				},
			},
			{
				path: '/campaign/additional-material/:requestId/approve',
				name: 'CampaignsAdditionalMaterialApprove',
				component: () => import('~/views/CampaignsAdditionalMaterialApprove.vue'),
				meta: {
					permissions: [ {
						subject: 'Campaign',
						action: 'createAdditionalMaterialRequest',
					} ],
				},
			},
			{
				path: '/campaign/additional-material/:requestId',
				name: 'CampaignsAdditionalMaterialDetail',
				component: () => import('~/views/CampaignsAdditionalMaterialEdit.vue'),
				meta: {
					permissions: [ {
						subject: 'Campaign',
						action: 'createAdditionalMaterialRequest',
					} ],
				},
			},
			{
				path: '/campaign/order/list',
				name: 'CampaignsOrderList',
				component: () => import('~/views/CampaignsOrderList.vue'),
				meta: {
					permissions: [ {
						subject: 'Campaign',
						action: 'viewSplitStatistics',
					} ],
				},
			},
			{
				path: '/campaign/brief/list',
				name: 'CampaignsBriefList',
				component: () => import('~/views/CampaignsBriefList.vue'),
				meta: {
					permissions: [ {
						subject: 'Campaign',
						action: 'all',
					} ],
				},
			},
			{
				path: '/campaign/brief/printer',
				name: 'CampaignsBriefPrinterList',
				component: () => import('~/views/CampaignsBriefPrinterList.vue'),
				meta: {
					permissions: [ {
						subject: 'Campaign',
						action: 'uploadPrintData',
					}, {
						subject: 'Campaign',
						action: 'confirmPrintOrders',
					} ],
				},
			},
			{
				path: '/campaign/brief/:briefId/upload-data',
				name: 'CampaignsBriefData',
				component: () => import('~/views/CampaignsBriefUploadData.vue'),
				meta: {
					permissions: [ {
						subject: 'Campaign',
						action: 'uploadPrintData',
					} ],
				},
			},
			{
				path: '/campaign/brief/:briefId/confirm-completion',
				name: 'CampaignsBriefConfirmCompletion',
				component: () => import('~/views/CampaignsBriefConfirmCompletion.vue'),
				meta: {
					permissions: [ {
						subject: 'Campaign',
						action: 'confirmPrintOrders',
					} ],
				},
			},
			{
				path: '/campaign/filter/list',
				name: 'CampaignsFilterList',
				component: () => import('~/views/CampaignsFilterList.vue'),
				meta: {
					permissions: [ {
						subject: 'Campaign',
						action: 'all',
					} ],
				},
			},
			{
				path: '/campaign/filter/add',
				name: 'CampaignsFilterAddition',
				component: () => import('~/views/CampaignsFilterEdit.vue'),
				meta: {
					permissions: [ {
						subject: 'Campaign',
						action: 'manageMarketSplitFilters',
					} ],
				},
			},
			{
				path: '/campaign/filter/:filterId',
				name: 'CampaignsFilterDetail',
				component: () => import('~/views/CampaignsFilterEdit.vue'),
				meta: {
					permissions: [ {
						subject: 'Campaign',
						action: 'manageMarketSplitFilters',
					} ],
				},
			},
			{
				path: '/campaign/filter/group/add',
				name: 'CampaignsFilterGroupAddition',
				component: () => import('~/views/CampaignsFilterGroupEdit.vue'),
				meta: {
					permissions: [ {
						subject: 'Campaign',
						action: 'manageMarketSplitFilters',
					} ],
				},
			},
			{
				path: '/campaign/filter/group/:groupId',
				name: 'CampaignsFilterGroupDetail',
				component: () => import('~/views/CampaignsFilterGroupEdit.vue'),
				meta: {
					permissions: [ {
						subject: 'Campaign',
						action: 'manageMarketSplitFilters',
					} ],
				},
			},
			{
				path: '/campaign/filter/group/:groupId/photos',
				name: 'CampaignsFilterGroupPhotos',
				component: () => import('~/views/CampaignsFilterGroupPhotos.vue'),
				meta: {
					permissions: [ {
						subject: 'Campaign',
						action: 'manageMarketSplitFilters',
					} ],
				},
			},
			{
				path: '/campaign/plan-changes',
				name: 'CampaignsPlanChanges',
				component: () => import('~/views/CampaignsPlanChanges.vue'),
				meta: {
					permissions: [ {
						subject: 'Campaign',
						action: 'all',
					} ],
				},
			},
		],
	},
] satisfies RouteDefinition[];
